



















































import { Component, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

import ModalOptions from '@/components/Modal/ModalOptions';
import ProgressbarInfo from '@/componentsV2/molecules/ProgressbarInfo/ProgressbarInfo.vue';

import isMobile from '@/utils/mobile-check';
import eventBus from '@/utils/eventBus';
import {
  Campaign,
  TCustomerLimitType
} from '@/models/marketingCenter/freeCoins';
import DateUtils from '@/utils/DateUtils';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Typography,
    Checkbox,
    ProgressbarInfo
  }
})
export default class CampaignStatus extends BillingModel {
  @Prop() readonly status?: boolean;
  @Prop() readonly campaignId?: string;
  @Prop() readonly hasActiveCampaign?: boolean;
  @Prop() readonly coinsClaimed?: string | number;
  @Prop() readonly customersClaimed?: string | number;
  @Prop() customerLimit?: number;
  @Prop() customerLimitType?: TCustomerLimitType;
  @Prop() campaign!: Campaign;

  get isMobileDevice() {
    return isMobile();
  }

  triggerActivation() {
    if (this.showActivateBillingBanner) {
      eventBus.$emit('upgradeBillingBanner', false);
      return;
    }
    if (!this.status) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptions(
          ``,
          ``,
          'none',
          true,
          ``,
          ``,
          ``,
          false,
          'offerFreeCoinsConfirmModal',
          false,
          true,
          true,
          true,
          true
        ),
        {
          status: this.status,
          campaignId: this.campaignId,
          hasActiveCampaign: this.hasActiveCampaign
        }
      );
    } else {
      eventBus.$emit('changeFreeCoinCampaignStatus', {
        status: this.status,
        id: this.campaignId
      });
    }
  }

  chartColor(getter: { title: string; percentage: number }) {
    return getter.percentage === 0 ? '#8195A4' : '#405F7A';
  }

  get showActivateBillingBanner() {
    return this.inactiveBilling;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get customersLabel() {
    let title = `No total member limit`;
    const isLimit = this.customerLimitType !== 'no-limit';

    if (isLimit && this.customerLimit) {
      title = `${this.customersClaimed}/${this.customerLimit || '-'} members ${
        this.customersClaimed === this.customerLimit ? '' : 'until limit'
      }`;
    }

    return {
      title: title,
      percentage: isLimit
        ? this.getPercentage(this.customersClaimed, this.customerLimit)
        : 0
    };
  }

  getBorderRadius(percentage: string) {
    if (Number(percentage.replace(/[^0-9]/g, '')) < 100)
      return '16px 1px 1px 16px';
    return '16px';
  }

  getPercentage(value1?: number | string, value2?: number | string) {
    if (!value1 && !value2) return 0;

    return ((Number(value1) / Number(value2)) * 100).toFixed(0);
  }

  get expirationLabel() {
    const isLimit = !!this.campaign.dateLimit;

    if (isLimit) {
      const differenceDaysCreated = DateUtils.getDifferenceDays(
        this.campaign.createdAt || '',
        this.campaign.dateLimit || ''
      );

      const differenceDaysToday = DateUtils.getDifferenceDays(
        this.campaign.createdAt || '',
        DateUtils.formatDate(new Date())
      );

      const differenceDaysTodayLimited = Math.min(
        differenceDaysToday,
        differenceDaysCreated
      );

      return {
        title: `${differenceDaysTodayLimited}/${differenceDaysCreated} days until deadline`,
        percentage: this.getPercentage(
          differenceDaysTodayLimited,
          differenceDaysCreated
        )
      };
    }

    return {
      title: 'No expiration date limit',
      percentage: 0
    };
  }

  onShare() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'campaignShareModal',
        false,
        true,
        true,
        true,
        true
      ),
      { modalViewEvent: 'Free Coins/Share' }
    );

    this.$analytics({
      eventCategory: 'Free Coins Campaign | Share campaign button',
      eventAction: 'click',
      eventLabel: 'Clicked on Share campaign button'
    });
  }
}
